// import React, { useState } from "react";
// import { NavLink } from "react-router-dom";
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Collapse,
//   AppBar,
//   Toolbar,
//   Typography,
//   IconButton,
//   Box,
// } from "@mui/material";
// import {
//   Dashboard as DashboardIcon,
//   Inventory as InventoryIcon,
//   ExpandLess,
//   ExpandMore,
//   Settings as SettingsIcon,
//   Store as StoreIcon,
//   Menu as MenuIcon,
// } from "@mui/icons-material";

// const DrawerMenu = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [submenuOpen, setSubmenuOpen] = useState(false);
//   const [submenuOpen2, setSubmenuOpen2] = useState(false);

//   const toggleDrawer = () => setDrawerOpen(!drawerOpen);
//   const toggleSubmenu = () => setSubmenuOpen(!submenuOpen);
//   const toggleSubmenu2 = () => setSubmenuOpen2(!submenuOpen2);
//   return (
//     <div>
//       {/* Top AppBar */}
//       <AppBar position="fixed" sx={{ backgroundColor: "#2c3e50", color: "#ecf0f1" }}>
//         <Toolbar>
//           <IconButton edge="start" color="inherit" onClick={toggleDrawer}>
//             <MenuIcon />
//           </IconButton>
//           <Typography variant="h6" noWrap>
//             Command Centre
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       {/* Space for the Topbar */}
//       <Box sx={{ height: "64px" }} />

//       {/* Drawer Menu */}
//       <Drawer
//         anchor="left"
//         open={true}
//         onClose={toggleDrawer}
//         PaperProps={{
//           style: { top: "64px", width: "250px" }, // Drawer starts below the AppBar
//         }}
//       >
//         <List>
//           {/* Dashboard */}
//           <ListItem disablePadding>
//             <ListItemButton component={NavLink} to="/" onClick={toggleDrawer}>
//               <ListItemIcon>
//                 <DashboardIcon />
//               </ListItemIcon>
//               <ListItemText primary="Dashboard" />
//             </ListItemButton>
//           </ListItem>

//           {/* Production with Expandable Submenu */}
//           <ListItem disablePadding>
//             <ListItemButton onClick={toggleSubmenu}>
//               <ListItemIcon>
//                 <SettingsIcon />
//               </ListItemIcon>
//               <ListItemText primary="Production" />
//               {submenuOpen ? <ExpandLess /> : <ExpandMore />}
//             </ListItemButton>
//           </ListItem>
//           <Collapse in={submenuOpen} timeout="auto" unmountOnExit>
//             <List component="div" disablePadding>
//               <ListItemButton
//                 sx={{ pl: 8 }} // Push submenu items to the right
//                 component={NavLink}
//                 to="/maintenanceHome"
//                 onClick={toggleDrawer}
//               >
//                 <ListItemText primary="Maintenance" />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{ pl: 8 }}
//                 component={NavLink}
//                 to="/production-plan"
//                 onClick={toggleDrawer}
//               >
//                 <ListItemText primary="Production Plan" />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{ pl: 8 }}
//                 component={NavLink}
//                 to="/machineList"
//                 onClick={toggleDrawer}
//               >
//                 <ListItemText primary="Machine List" />
//               </ListItemButton>
//             </List>
//           </Collapse>

//           {/* Warranty */}
//           <ListItem disablePadding>
//             <ListItemButton component={NavLink} to="/efficiencyHome" onClick={toggleDrawer}>
//               <ListItemIcon>
//                 <InventoryIcon />
//               </ListItemIcon>
//               <ListItemText primary="Warranty" />
//             </ListItemButton>
//           </ListItem>

//           {/* Store */}
//           <ListItem disablePadding>
//             <ListItemButton onClick={toggleSubmenu2}>
//               <ListItemIcon>
//                 <StoreIcon />
//               </ListItemIcon>
//               <ListItemText primary="Store" />
//               {submenuOpen2 ? <ExpandLess /> : <ExpandMore />}
//             </ListItemButton>
//           </ListItem>
//           <Collapse in={submenuOpen2} timeout="auto" unmountOnExit>
//             <List component="div" disablePadding>
//               <ListItemButton
//                 sx={{ pl: 8 }} // Push submenu items to the right
//                 component={NavLink}
//                 to="/inventory"
//                 onClick={toggleDrawer}
//               >
//                 <ListItemText primary="Inventory" />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{ pl: 8 }}
//                 component={NavLink}
//                 to="/products"
//                 onClick={toggleDrawer}
//               >
//                 <ListItemText primary="Products" />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{ pl: 8 }}
//                 component={NavLink}
//                 to="/vendors"
//                 onClick={toggleDrawer}
//               >
//                 <ListItemText primary="Vendors" />
//               </ListItemButton>
//               <ListItemButton
//                   sx={{ pl: 8 }}
//                   component={NavLink}
//                   to="/issue-receive-items"
//                   onClick={toggleDrawer}
//                 >
//                 <ListItemText primary="Issue Receive Items" />
//               </ListItemButton>
//             </List>
//           </Collapse>
//         </List>
//       </Drawer>
//     </div>
//   );
// };

// export default DrawerMenu;
import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  AppBar,
  Collapse,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Box,
  colors,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Inventory as InventoryIcon,
  Settings as SettingsIcon,
  Store as StoreIcon,
    ExpandLess,
  ExpandMore,
  AccountCircle as AccountCircleIcon,
  AirlineSeatIndividualSuiteSharp,
  Factory,
  Apps,
  SupervisedUserCircleOutlined,
} from "@mui/icons-material";
import { useSelector, useDispatch } from 'react-redux';
import { setLogout } from "../state";

const DrawerMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token); // Access token from Redux state
  const [isRootUser, setIsRootUser] = useState(user?.role === 'Root User' || user?.role === 'Super Admin' ? true : false);

const imgMIS = require('../assets/VARENYA EXPERIENCE 1.png');

  const [time, setTime] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState(null);

  // const handleLogout = () => {
  //   dispatch(setLogout())
  //   navigate('/');
  // };

  const handleLogout = async () => {
  // const token = localStorage.getItem('token'); // Ensure you retrieve the token

  if (!token) {
    console.error("No token found for logout.");
    return;
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_USERMGMT_URL}/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, // Include the token in the header
      },
    });

    if (response.ok) {
      dispatch(setLogout()); // Dispatch logout action
      navigate('/'); // Navigate to the home page
    } else {
      const errorData = await response.json();
      console.error('Logout failed:', errorData);
    }
  } catch (error) {
    console.error('Error during logout:', error);
  }
};

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const [submenuOpen, setSubmenuOpen] = useState(false);
    const [submenuOpen2, setSubmenuOpen2] = useState(false);
  
    const toggleSubmenu = () => setSubmenuOpen(!submenuOpen);
    const toggleSubmenu2 = () => setSubmenuOpen2(!submenuOpen2);
    const myLayerText = {
      width: "120px",
      height:"50px",
    };
  return (
    <div>
      {/* Top AppBar */}
      <AppBar position="fixed" sx={{ backgroundColor: "#4863A0"}}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Time and Date on the left */}
          <IconButton edge="start" color="inherit" >
             <img
                       style={myLayerText}
                       src={imgMIS}
                       alt="Logo"
             />
           </IconButton>
           {/* <Typography variant="h6" noWrap>
             Command Centre
           </Typography> */}
          {/* <Typography variant="body1" sx={{ textAlign: "left", marginLeft:"200px" }}>
            {time.toLocaleString()}
          </Typography> */}

          {/* Application Name in the center */}
          <Typography variant="h4" sx={{ textAlign: "center", marginLeft:"140px"  }}>
             Aryan Management Information System 
          </Typography>

          {/* Login Icon on the right */}
          <Box display="flex" alignItems="center" gap="8px">
            {user ? ( // Check if user is defined
              <>
                <Typography variant="body1">
                  {user.userName} - {user.role}
                </Typography>
                <IconButton edge="end" color="inherit" onClick={handleMenuOpen}>
                  <AccountCircleIcon />
                </IconButton>
              </>
            ) : (
              <Typography variant="body1">Guest</Typography> // Fallback for logged-out state
            )}
          </Box>

          {/* Dropdown Menu for Account Options */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleMenuClose}>Account Details</MenuItem>
            <MenuItem onClick={handleMenuClose}>Change Password</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Sidebar always open */}
      <Drawer
        variant="permanent"
        PaperProps={{
          style: { top: "64px", width: "200px" }, // Always visible, below AppBar
        }}
      >
        <List>
          {/* Dashboard */}
          <ListItem disablePadding>
            <ListItemButton component={NavLink} to="/home">
              <ListItemIcon sx={{ color: "#4863A0", mr: -3  }}> {/* Change icon color here */}
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }} /> {/* Increase size and weight */}
            </ListItemButton>
          </ListItem>

          {/* Production */}
          <ListItem disablePadding>
            <ListItemButton onClick={toggleSubmenu}>
                <ListItemIcon sx={{ color: "#4863A0", mr: -3 }}>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Production" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}/>
                {submenuOpen ? <ExpandLess sx={{ mr: 6 }} /> : <ExpandMore sx={{ mr: 6 }} />}
              </ListItemButton>
          </ListItem>
          <Collapse in={submenuOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 8 }} // Push submenu items to the right
                  component={NavLink}
                  to="/maintenanceHome"
                >
                  <ListItemText primary="Maintenance" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 8 }}
                  component={NavLink}
                  to="/production-tabs"
                >
                  <ListItemText primary="Production Plan" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 8 }}
                  component={NavLink}
                  to="/product-tabs"
                >
                  <ListItemText primary="Products" />
                </ListItemButton>
              </List>
          </Collapse>

          {/* Warranty */}
          <ListItem disablePadding>
            <ListItemButton component={NavLink} to="/efficiencyHome">
              <ListItemIcon sx={{ color: "#4863A0", mr: -3 }}>
                <InventoryIcon />
              </ListItemIcon>
              <ListItemText primary="Warranty" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}/>
            </ListItemButton>
          </ListItem>

          {/* Store */}
          <ListItem disablePadding>
             <ListItemButton onClick={toggleSubmenu2}>
               <ListItemIcon sx={{ color: "#4863A0", mr: -3 }}>
                 <StoreIcon />
               </ListItemIcon>
               <ListItemText primary="Store" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}/>
               {submenuOpen2 ? <ExpandLess sx={{ mr: 10 }} /> : <ExpandMore sx={{ mr: 10 }} />}
             </ListItemButton>
           </ListItem>
           <Collapse in={submenuOpen2} timeout="auto" unmountOnExit>
             <List component="div" disablePadding>
               <ListItemButton
                sx={{ pl: 8 }} // Push submenu items to the right
                component={NavLink}
                to="/inventoryHome"
              >
                <ListItemText primary="Inventory" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 8 }}
                component={NavLink}
                to="/rawMaterialHome"
              >
                <ListItemText primary="Raw Materials" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 8 }}
                component={NavLink}
                to="/vendorHome"
              >
                <ListItemText primary="Vendors" />
              </ListItemButton>
              <ListItemButton
                  sx={{ pl: 8 }}
                  component={NavLink}
                  to="/issueReceiveItemHome"
                >
                <ListItemText primary="Issue Receive Items" />
              </ListItemButton>
            </List>
          </Collapse>
          {isRootUser && ( 
          <ListItem disablePadding>
            <ListItemButton component={NavLink} to="/register">
              <ListItemIcon sx={{ color: "#4863A0", mr: -3 }}>
                <SupervisedUserCircleOutlined />
              </ListItemIcon>
              <ListItemText primary="Team" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }} />
            </ListItemButton>
          </ListItem>
          )}
        </List>
      </Drawer>

      {/* Space for Sidebar and AppBar */}
      
    </div>
  );
};

export default DrawerMenu;